var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7478 2.9469C16.1229 2.57196 16.6315 2.36133 17.1618 2.36133C17.6922 2.36133 18.2008 2.57196 18.5758 2.9469L21.0508 5.4219C21.2366 5.60763 21.384 5.82814 21.4846 6.07085C21.5851 6.31355 21.6369 6.57369 21.6369 6.8364C21.6369 7.09911 21.5851 7.35925 21.4846 7.60196C21.384 7.84466 21.2366 8.06517 21.0508 8.2509L9.15783 20.1439L4.16421 20.9861C3.48594 21.1005 2.89736 20.5118 3.01186 19.8336L3.85483 14.8399L15.7478 2.9469ZM15.5188 6.0039L17.9938 8.4789L19.6368 6.8359L17.1618 4.3619L15.5188 6.0039ZM16.5788 9.8939L14.1048 7.4189L5.72083 15.8029L5.21783 18.7799L8.19483 18.2779L12.3873 14.0854L16.5798 9.8929L16.5788 9.8939Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/edit-icon-2.397a7b179ade1212e26a779e43f3ce27.svg";
export { ForwardRef as ReactComponent };